import "./index.css";
import { AbsolutePlatform } from "../shared/AbsolutePlatform";
import { Suspense, useEffect, useState } from "react";
import { initialProjectDirectory } from "../entities/initialProjectDirectory";
import { ClientNotFoundPage, MainPage } from "../pages";
import { Loading } from "../shared/Loading";
import { Route, Routes, useNavigate } from "react-router-dom";
import { NotFoundPage } from "../pages";
import { clientTokenName } from "../entities/clientTokenName";

export const App = () => {
  const navigate = useNavigate();
  const clientTokenStringState = useState();

  const [clientTokenStringStateValue, setClientTokenStringStateValue] =
    clientTokenStringState;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const clientIdParamValue = urlParams.get("client_id");
    if (clientIdParamValue) {
      sessionStorage.setItem(clientTokenName, clientIdParamValue);
      setClientTokenStringStateValue(clientIdParamValue);
    } else {
      navigate(`${initialProjectDirectory}/clientNotFound`);
    }
  }, []);

  if (!clientTokenStringStateValue)
    return (
      <AbsolutePlatform
        maxWidth={1350}
        secondClassName="global_content_container"
      >
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route
              exact
              path={`${initialProjectDirectory}/`}
              element={<Loading />}
            ></Route>
            <Route
              exact
              path={`${initialProjectDirectory}/clientNotFound`}
              element={<ClientNotFoundPage />}
            ></Route>

            <Route exact path="*" element={<NotFoundPage />}></Route>
          </Routes>
        </Suspense>
      </AbsolutePlatform>
    );

  return (
    <AbsolutePlatform
      maxWidth={1350}
      secondClassName="global_content_container"
    >
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route
            exact
            path={`${initialProjectDirectory}/`}
            element={<MainPage />}
          ></Route>
          <Route
            exact
            path={`${initialProjectDirectory}/clientNotFound`}
            element={<ClientNotFoundPage />}
          ></Route>

          <Route exact path="*" element={<NotFoundPage />}></Route>
        </Routes>
      </Suspense>
    </AbsolutePlatform>
  );
};
